import { useCallback } from 'react';
import { useLocalSearchParams, useRouter } from 'expo-router';

export type TActivityFiltersSearchParams = {
  periodId: string;
  from: string;
  to: string;
};

export const useActivityFilters = () => {
  const router = useRouter();
  const queryParams = useLocalSearchParams<TActivityFiltersSearchParams>();

  const setFilters = useCallback(
    (filters: TActivityFiltersSearchParams) => router.setParams(filters),
    [router]
  );

  const from = queryParams.from;
  const to = queryParams.to;

  return {
    filters: queryParams,
    setFilters,
    periodId: queryParams.periodId,
    from,
    to,
    hasPeriodRange: Boolean(from && to),
  };
};
